/************************************************************************
*************************************************************************
*
* Util Tools
*
*
*
■javascript機能追加
・trimの有効化
・Object.keysの有効化
・dirname 対象URLのディレクトリ名取得
・dirname 対象URLのディレクトリ名取得(相対パス対応、絶対パスに変換)
・basename URLからファイル名取得


■コンバート用Util
・URLパラメータ取得
・cookie取得（単一値）
・cookie取得（全て）
・cookie削除
・全角　→　半角
・半角　→　全角
・大文字　→　小文字
・小文字　→　大文字
・URLエンコード
・URLデコード
・桁埋め
・日付の足し算/引き算（2015/11/30　＋　7日）
・日付期間計算（2015/11/30　～　2015/12/15　=　15）
・日付フォーマット変換
・日付取得（年/月/日/曜日/時間/分/秒）
・少数（切り上げ/切り捨て/四捨五入/丸め）
・正規表現（文字列からパターン作成）
・文字列から数値を切り抜く
・桁数カンマ区切り
・Date型の曜日を取得
・共通の値を抽出する（Object）
・共通の値を抽出する（Array）


■チェック用Util
・型判定（Object）
・型判定（Array）
・型判定（Function）
・型判定（Error）
・型判定（Date）
・型判定（JSON）
・型判定（RegExp）
・型判定（String）
・型判定（Number）
・型判定（Boolean）
・型判定
・半角
・半角英数
・半角英数記号(ASCII)　http://windyrings.jugem.jp/?eid=835
・半角カナ
・全角
・全角カナ
・数値
・少数
・メールアドレス
・電話番号
・携帯番号
・日付（年月日）
・時刻
・確認項目（パスワード、アドレスの確認があっているか）
・URL
・郵便番号
・クレジットカード

・null
・空
・undefined
・0
・isset

・文字数上限/下限
・機種依存文字
・日付期間のチェック（開始～終了）
・数値範囲
・ページ判定
・ページ判定(正規表現)


■タグ変換
・タグ変換（文字列などの配列　→　selectboxなど）


*
*
*************************************************************************
*************************************************************************/

function UtilTools() {}
var Util = new UtilTools();



/*=======================================================================
=========================================================================
=
= 機能追加
=
=========================================================================
========================================================================/

/*-----------------------------------------------------------------------
- trimの有効化
-----------------------------------------------------------------------*/
if(!String.prototype.trim) {
	String.prototype.trim = function () {
		return this.replace(/^\s+|\s+$/g,'');
	};
}

/*-----------------------------------------------------------------------
- Object.keysの有効化
-----------------------------------------------------------------------*/
if(!Object.keys){
	Object.keys = function(obj){
		var keys = [];
		for(var i in obj){
			if(obj.hasOwnProperty(i)){
				keys.push(i);
			}
		}
		return keys;
	};
}

/*-----------------------------------------------------------------------
- dirname 対象URLのディレクトリ名取得 [data=str;]
-----------------------------------------------------------------------*/
UtilTools.prototype.dirname = function(data) {
	return data.replace(/\\/g,'/').replace(/\/[^\/]*$/, '') + '/';
}

/*-----------------------------------------------------------------------
- dirname 対象URLのディレクトリ名取得(相対パス対応、絶対パスに変換) [data=str;]
-----------------------------------------------------------------------*/
UtilTools.prototype.dirnameRelative = function(data) {
	var dirname = UtilTools.prototype.dirname(data);
	// プロトコルとホスト削除
	dirname = dirname.replace( location.protocol + '//' + location.host + '/', '' );
	
	return dirname;
}

/*-----------------------------------------------------------------------
- basename URLからファイル名取得 [data=str;]
-----------------------------------------------------------------------*/
UtilTools.prototype.basename = function(data) {
	var filename = data.replace(/\\/g,'/').replace( /.*\//, '' );
	
	// クエリ削除
	filename = filename.split('?');
	filename = filename.shift();
	
	// ハッシュ削除
	filename = filename.split('#');
	filename = filename.shift();
	
	return filename;
}



/*=======================================================================
=========================================================================
=
= コンバート用
=
=========================================================================
========================================================================/

/*-----------------------------------------------------------------------
- URLパラメータ取得（連想配列で返す） [data=str;]
-----------------------------------------------------------------------*/
UtilTools.prototype.getQueryParams = function(data) {
	
	var queryString, queryItems, queryItem,
		i, length, matchs, key, pkey, skey, value, list, hash, params = {};
 	
	// クエリストリングの取得
	if(arguments.length){
		queryString = data;
	}else{
		queryString = window.location.search || '';
	}
	queryString = queryString.substr(1, queryString.length);
 	
	// パラメター毎に分解
	queryItems = queryString.split('&');
 	
	// 各パラメターをキー&バリューに分解
	for (i = 0, length = queryItems.length; i < length; i++) {
		// 1組取り出し
		queryItem = (queryItems[i] || '').split('=');
 		
		// キー&バリューに分解
		key = queryItem[0];
		value = queryItem[1] ? queryItem[1] : '';
 		
		// キー文字列によってオブジェクトの作り方を変える
		matchs = (/([\w$]*)\[([\w$]*)\]/g).exec(key);
		if (matchs === null) {
			// 単純なキー&バリュー
			params[key] = value;
		} else {
			pkey = matchs[1];
			skey = matchs[2];
			if (!skey) {
				// 配列にバリューを格納
				list = params[pkey] = params[pkey] || [];
				list[list.length] = value;
			} else {
				// ハッシュにサブキーとバリューを格納
				hash = params[pkey] = params[pkey] || {};
				hash[skey] = value;
			}
		}
	}
	
	return params;
	
}


/*-----------------------------------------------------------------------
- cookie取得（単一値） [name=cookie名;]
-----------------------------------------------------------------------*/
UtilTools.prototype.getCookie = function(name) {
	var result = null;
	if(UtilTools.prototype.isEmpty(name)){
		return result;
	}
	
	var cookieName = encodeURIComponent(name) + '=';
	var allCookies = document.cookie;
	
	var position = allCookies.indexOf(cookieName);
	if( ~position ){
		var startIndex = position + cookieName.length;
		var endIndex = allCookies.indexOf(';', startIndex);
		if(endIndex == -1){
			endIndex = allCookies.length;
		}
		
		result = decodeURIComponent(allCookies.substring( startIndex, endIndex ));
	}
	
	return result;
}


/*-----------------------------------------------------------------------
- cookie取得（全て）
-----------------------------------------------------------------------*/
UtilTools.prototype.getCookies = function() {
	var result = {};
	var allCookies = document.cookie;
	if(allCookies != ''){
		var cookies = allCookies.split( '; ' );
		for(var i = 0; i < cookies.length; i++){
			var cookie = cookies[i].split('=');
			// クッキーの名前をキーとして 配列に追加する
			result[decodeURIComponent(cookie[0])] = decodeURIComponent(cookie[1]);
		}
	}
	return result;
}


/*-----------------------------------------------------------------------
- cookie設定 [name=cookie名;value=値;setting={各種設定}]
-             settingの設定内容は以下の通り
-               path    : クッキーが有効なパス ext) /foo/
-               domain  : クッキーが有効なドメイン ext) example.com
-               max-age : クッキーの有効期限 (秒数で指定) ext) 3600
-               secure  : HTTPS接続でのみクッキーを使用するかどうか ext) true
-----------------------------------------------------------------------*/
UtilTools.prototype.setCookie = function(name, value, setting) {
	var cookie = encodeURIComponent(name) + '=' + encodeURIComponent(value);
	
	// 設定内容がセットされているか判定（構造体か判定）
	if(setting instanceof Object && !(setting instanceof Array)){
		
		// 有効なpathの設定
		if(UtilTools.prototype.isSet(setting['path'])){
			cookie += '; path=' + setting['path'];
		}
		
		// 有効なdomainの設定
		if(UtilTools.prototype.isSet(setting['domain'])){
			cookie += '; domain=' + setting['domain'];
		}
		
		// 有効期限
		if(UtilTools.prototype.isSet(setting['max-age'])){
			cookie += '; max-age=' + setting['max-age'];
		}
		
		// HTTPS接続のみでの使用設定
		if(UtilTools.prototype.isSet(setting['secure'])){
			cookie += '; secure=' + setting['secure'];
		}
	}
	
	document.cookie = cookie;
}


/*-----------------------------------------------------------------------
- cookie削除 [name=cookie名;]
-----------------------------------------------------------------------*/
UtilTools.prototype.deleteCookie = function(name, setting) {
	// 空のcookieをセット
	var cookie = encodeURIComponent(name) + '=';
	
	// 設定内容がセットされているか判定（構造体か判定）
	if(setting instanceof Object && !(setting instanceof Array)){
		
		// 有効なpathの設定
		if(UtilTools.prototype.isSet(setting['path'])){
			cookie += '; path=' + setting['path'];
		}
		
		// 有効なdomainの設定
		if(UtilTools.prototype.isSet(setting['domain'])){
			cookie += '; domain=' + setting['domain'];
		}
		
		// HTTPS接続のみでの使用設定
		if(UtilTools.prototype.isSet(setting['secure'])){
			cookie += '; secure=' + setting['secure'];
		}
	}
	// 有効期限を0とすることでクッキーを削除
	cookie += '; max-age=0';
	
	document.cookie = cookie;
}


/*-----------------------------------------------------------------------
- 全角　→　半角 [data=str;]
-----------------------------------------------------------------------*/
UtilTools.prototype.convertToHalf = function(data) {
	return data.replace(/[Ａ-Ｚａ-ｚ０-９]/g, function(s) {
		return String.fromCharCode(s.charCodeAt(0) - 0xFEE0);
	});
}


/*-----------------------------------------------------------------------
- 半角　→　全角 [data=str;]
-----------------------------------------------------------------------*/
UtilTools.prototype.convertToFull = function(data) {
	return data.replace(/[A-Za-z0-9]/g, function(s) {
		return String.fromCharCode(s.charCodeAt(0) + 0xFEE0);
	});
}


/*-----------------------------------------------------------------------
- 大文字　→　小文字 [data=str;]
-----------------------------------------------------------------------*/
UtilTools.prototype.convertToLower = function(data) {
	return data.toLowerCase();
}


/*-----------------------------------------------------------------------
- 小文字　→　大文字 [data=str;]
-----------------------------------------------------------------------*/
UtilTools.prototype.convertToUpper = function(data) {
	return data.toUpperCase();
}


/*-----------------------------------------------------------------------
- URLエンコード [data=str;]
-----------------------------------------------------------------------*/
UtilTools.prototype.encodeUri = function(data) {
	return encodeURIComponent(data);
}


/*-----------------------------------------------------------------------
- URLデコード [data=str;]
-----------------------------------------------------------------------*/
UtilTools.prototype.decodeUri = function(data) {
	return decodeURIComponent(data);
}


/*-----------------------------------------------------------------------
- 桁埋め [num=int,str; digit=int;]
-----------------------------------------------------------------------*/
UtilTools.prototype.Ketaume = function(num, digit) {
	
	// 0ケタ以下の表示は不可能なためそのままnumを返す
	if(digit < 1)
		return num;
	
	
	var ketaumeStr = '0';
	var zero = '';
	
	for(var i=1; i<digit; i++){
		zero += ketaumeStr;
	}
	
	var result = ( zero + num ).slice( -digit );
	return result;
	
}


/*-----------------------------------------------------------------------
- 正規表現（文字列からパターン作成） [str=str;]
-----------------------------------------------------------------------*/
UtilTools.prototype.StrToRegexPattern = function(str) {
	
	var result = new RegExp(str);
	return result;
	
}


/*-----------------------------------------------------------------------
- 文字列から数値を切り抜く [str=str;]
-----------------------------------------------------------------------*/
UtilTools.prototype.getNumberFromString = function(data) {
	var result = data.replace(/[^0-9]/g,'') - 0;
	return result;
}


/*-----------------------------------------------------------------------
- 桁数カンマ区切り [str=str,int;]
-----------------------------------------------------------------------*/
UtilTools.prototype.addCommaSeparat = function(data) {
	var result = data.toString().replace( /(\d)(?=(\d\d\d)+(?!\d))/g, '$1,');
	return result;
}


/*-----------------------------------------------------------------------
- Date型の曜日を取得する [data=Date,int]
-----------------------------------------------------------------------*/
UtilTools.prototype.getWeekday = function(data) {
	var week = ["日","月","火","水","木","金","土"];
	// 引数が日付型の場合
	if(UtilTools.prototype.isTypeDate(data)){
		return week[data.getDay()];
	}
	// 引数が整数の場合
	if(UtilTools.prototype.isTypeNumber(data) && UtilTools.prototype.isBetweenNum(data, 0, 6)){
		return week[data];
	}
	
	// 引数が想定外の場合はnull
	return null;
}


/*-----------------------------------------------------------------------
- 共通の値を抽出する（Object） [obj1=object;obj2=object]
-----------------------------------------------------------------------*/
UtilTools.prototype.getCommonObjectData = function(obj1, obj2) {
	
	var commonValueObject = {};
	
	// どちらかがオブジェクトではない場合処理終了
	if(!UtilTools.prototype.isTypeObject(obj1) || !UtilTools.prototype.isTypeObject(obj2)){
		return commonValueObject;
	}
	
	// 全てのオブジェクトを比較し、同一値のものを共通項目とする
	for(var key in obj1){
		if(obj1[key] != null && obj1[key] == obj2[key]){
			commonValueObject[key] = obj1[key];
		}
	}
	
	return commonValueObject;
}


/*-----------------------------------------------------------------------
- 共通の値を抽出する（Array） [arr1=array;arr2=array]
-----------------------------------------------------------------------*/
UtilTools.prototype.getCommonArrayData = function(arr1, arr2) {
	
	var commonValueArray = [];
	
	// どちらかが配列ではない場合処理終了
	if(!UtilTools.prototype.isTypeArray(arr1) || !UtilTools.prototype.isTypeArray(arr2)){
		return commonValueArray;
	}
	
	// 全ての配列を比較し、同一値のものを共通項目とする
	for(var i=0; i<arr1.length; i++){
		
		for(var j=0; j<arr2.length; j++){
			
			if(arr1[i] == arr2[j] && commonValueArray.indexOf(arr1[i]) < 0){
				commonValueArray.push(arr1[i]);
			}
			
		}
		
	}
	
	return commonValueArray;
}



/*=======================================================================
=========================================================================
=
= チェック用
=
=========================================================================
========================================================================/

/*-----------------------------------------------------------------------
- 型判定（Object） [data=object;]
-----------------------------------------------------------------------*/
UtilTools.prototype.isTypeObject = function(data) {
	var type = "Object";
	return UtilTools.prototype.isType(data, type);
}


/*-----------------------------------------------------------------------
- 型判定（Array） [data=object;]
-----------------------------------------------------------------------*/
UtilTools.prototype.isTypeArray = function(data) {
	var type = "Array";
	return UtilTools.prototype.isType(data, type);
}


/*-----------------------------------------------------------------------
- 型判定（Function） [data=object;]
-----------------------------------------------------------------------*/
UtilTools.prototype.isTypeFunction = function(data) {
	var type = "Function";
	return UtilTools.prototype.isType(data, type);
}


/*-----------------------------------------------------------------------
- 型判定（Error） [data=object;]
-----------------------------------------------------------------------*/
UtilTools.prototype.isTypeError = function(data) {
	var type = "Error";
	return UtilTools.prototype.isType(data, type);
}


/*-----------------------------------------------------------------------
- 型判定（Date） [data=object;]
-----------------------------------------------------------------------*/
UtilTools.prototype.isTypeDate = function(data) {
	var type = "Date";
	return UtilTools.prototype.isType(data, type);
}


/*-----------------------------------------------------------------------
- 型判定（JSON） [data=object;]
-----------------------------------------------------------------------*/
UtilTools.prototype.isTypeJSON = function(data) {
	var type = "JSON";
	return UtilTools.prototype.isType(data, type);
}


/*-----------------------------------------------------------------------
- 型判定（RegExp） [data=object;]
-----------------------------------------------------------------------*/
UtilTools.prototype.isTypeRegExp = function(data) {
	var type = "RegExp";
	return UtilTools.prototype.isType(data, type);
}


/*-----------------------------------------------------------------------
- 型判定（String） [data=object;]
-----------------------------------------------------------------------*/
UtilTools.prototype.isTypeString = function(data) {
	var type = "String";
	return UtilTools.prototype.isType(data, type);
}


/*-----------------------------------------------------------------------
- 型判定（Number） [data=object;]
-----------------------------------------------------------------------*/
UtilTools.prototype.isTypeNumber = function(data) {
	var type = "Number";
	return UtilTools.prototype.isType(data, type);
}


/*-----------------------------------------------------------------------
- 型判定（Boolean） [data=object;]
-----------------------------------------------------------------------*/
UtilTools.prototype.isTypeBoolean = function(data) {
	var type = "Boolean";
	return UtilTools.prototype.isType(data, type);
}


/*-----------------------------------------------------------------------
- 型判定 [data=object;type=str;]
-----------------------------------------------------------------------*/
UtilTools.prototype.isType = function(data, type) {
	var toString = Object.prototype.toString;
	if(toString.call(data).slice(8, -1) == type){
		return true
	}
	return false;
}


/*-----------------------------------------------------------------------
- 半角 [data=str;]
-----------------------------------------------------------------------*/
UtilTools.prototype.isHankaku = function(data) {
	for (var i = 0; i < data.length; i++) {
		var c = data.charCodeAt(i);
		// Shift_JIS: 0x0 ～ 0x80, 0xa0 , 0xa1 ～ 0xdf , 0xfd ～ 0xff
		// Unicode : 0x0 ～ 0x80, 0xf8f0, 0xff61 ～ 0xff9f, 0xf8f1 ～ 0xf8f3
		if ( !((c >= 0x0 && c < 0x81) || (c == 0xf8f0) || (c >= 0xff61 && c < 0xffa0) || (c >= 0xf8f1 && c < 0xf8f4)) ) {
			return false;
		}
	}
	return true;
}


/*-----------------------------------------------------------------------
- 半角英数 [data=str;]
-----------------------------------------------------------------------*/
UtilTools.prototype.isHankakuEisuu = function(data) {
	var pettern = /^[A-Za-z0-9]+$/;
	if(data.toString().match(pettern))
		return true;
	else
		return false;
}


/*-----------------------------------------------------------------------
- 半角英数記号 [data=str;]
-----------------------------------------------------------------------*/
UtilTools.prototype.isHankakuEisuuKigou = function(data) {
	var pettern = /^[a-zA-Z0-9!-/:-@\[-`{-~]+$/;
	if(data.toString().match(pettern))
		return true;
	else
		return false;
}


/*-----------------------------------------------------------------------
- 半角カナ [data=str;]
-----------------------------------------------------------------------*/
UtilTools.prototype.isHankakuKana = function(data) {
	var pettern = /^[ｧ-ﾝﾞﾟ]+$/;
	if(data.toString().match(pettern))
		return true;
	else
		return false;
}


/*-----------------------------------------------------------------------
- 全角 [data=str;]
-----------------------------------------------------------------------*/
UtilTools.prototype.isZenkaku = function(data) {
	for (var i = 0; i < data.length; i++) {
		var c = data.charCodeAt(i);
		// Shift_JIS: 0x0 ～ 0x80, 0xa0 , 0xa1 ～ 0xdf , 0xfd ～ 0xff
		// Unicode : 0x0 ～ 0x80, 0xf8f0, 0xff61 ～ 0xff9f, 0xf8f1 ～ 0xf8f3
		if ( (c >= 0x0 && c < 0x81) || (c == 0xf8f0) || (c >= 0xff61 && c < 0xffa0) || (c >= 0xf8f1 && c < 0xf8f4)) {
			return false;
		}
	}
	return true;
}


/*-----------------------------------------------------------------------
- 全角カナ [data=str;]
-----------------------------------------------------------------------*/
UtilTools.prototype.isZenkakuKana = function(data) {
	var pettern = /^[\u30A0-\u30FF]+$/;
	if(data.toString().match(pettern))
		return true;
	else
		return false;
}


/*-----------------------------------------------------------------------
- 数値 [data=str,int;]
-----------------------------------------------------------------------*/
UtilTools.prototype.isNum = function(data) {
	var pettern = /^-?[0-9]+$/;
	if(data.toString().match(pettern))
		return true;
	else
		return false;
}


/*-----------------------------------------------------------------------
- 少数(…XX.XX…の形式のみ) [data=str,int;]
-----------------------------------------------------------------------*/
UtilTools.prototype.isFew = function(data) {
	var pettern = /^-?[0-9]+\.[0-9]+$/;
	if(data.toString().match(pettern))
		return true;
	else
		return false;
}


/*-----------------------------------------------------------------------
- メールアドレス [data=str;]
-----------------------------------------------------------------------*/
UtilTools.prototype.isMailaddress = function(data) {
//	var pettern = /^[\w\.-]+@[\w\.-]+\.\w{2,}$/;
	// RFC5322
	var pettern = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
	if(data.toString().match(pettern))
		return true;
	else
		return false;
}


/*-----------------------------------------------------------------------
- 電話番号（市外局番からと市外局番からでは「-」の位置が違うのでチェックは難しい） [data=str;]
-----------------------------------------------------------------------*/
UtilTools.prototype.isTel = function(data) {
	var pettern = /^\d{1,4}-?\d{4}$|^\d{2,5}-?\d{1,4}-?\d{4}$/;
	if(data.toString().match(pettern))
		return true;
	else
		return false;
}


/*-----------------------------------------------------------------------
- 携帯番号「0X0-XXXX-XXXX、0X0XXXXXXXX（11桁）」 [data=str;]
-----------------------------------------------------------------------*/
UtilTools.prototype.isMobile = function(data) {
	var pettern = /^0\d0-\d{4}-\d{4}$|^0\d0\d{8}$/;
	if(data.toString().match(pettern))
		return true;
	else
		return false;
}


/*-----------------------------------------------------------------------
- 日付「yyyy/mm/dd、yyyy-mm-dd、yyyymmdd」（うるう年対策済み） [data=str;]
-----------------------------------------------------------------------*/
UtilTools.prototype.isDatetime = function(data) {
	if(data instanceof Date)
		return true;
	
	var pettern = /^(\d{4})(-|\/)?(0[1-9]|1[0-2])(-|\/)?(0[1-9]|[12][1-9]|[1-3]0|31)$/;
	var matches = data.toString().match(pettern);
	
	if(matches){
		// 取得した日付をDate型に変換
		var date = new Date(matches[1] +'/'+ matches[3] +'/'+ matches[5] );
		
		// 桁埋めしてjavascriptのDateと正しいか比較
		if(UtilTools.prototype.Ketaume(date.getFullYear(), 4) == matches[1] && UtilTools.prototype.Ketaume((date.getMonth() + 1), 2) == matches[3] && UtilTools.prototype.Ketaume(date.getDate(), 2) == matches[5])
			return true;
		else
			return false;
		
	}else{
		return false;
	}
}


/*-----------------------------------------------------------------------
- 日付（年） [data=str,int;]
-----------------------------------------------------------------------*/
UtilTools.prototype.isYear = function(data) {
	var pettern = /^\d{4}$/;
	if(data.toString().match(pettern))
		return true;
	else
		return false;
}


/*-----------------------------------------------------------------------
- 日付（月） [data=str,int;]
-----------------------------------------------------------------------*/
UtilTools.prototype.isMonth = function(data) {
	var pettern = /^(0[1-9]|1[0-2])$/;
	if(data.toString().match(pettern))
		return true;
	else
		return false;
}


/*-----------------------------------------------------------------------
- 日付（日） [data=str,int;]
-----------------------------------------------------------------------*/
UtilTools.prototype.isDate = function(data) {
	var pettern = /^(0[1-9]|[12][1-9]|[1-3]0|31)$/;
	if(data.toString().match(pettern))
		return true;
	else
		return false;
}


/*-----------------------------------------------------------------------
- 時刻 [data=str;]
-----------------------------------------------------------------------*/
UtilTools.prototype.isTime = function(data) {
	var pettern = /^([01]?[0-9]|2[0-3]):([0-5][0-9])$/;
	if(data.toString().match(pettern))
		return true;
	else
		return false;
}


/*-----------------------------------------------------------------------
- 確認用項目（パスワード、アドレスの確認があっているか） [data=str; confirm=str;]
-----------------------------------------------------------------------*/
UtilTools.prototype.isMatchConfirm = function(data, confirm) {
	if(data == confirm)
		return true;
	else
		return false;
}


/*-----------------------------------------------------------------------
- URL [data=str;]
-----------------------------------------------------------------------*/
UtilTools.prototype.isURL = function(data) {
	var pettern = /^(https?|ftp)(:\/\/[-_.!~*\'()a-zA-Z0-9;\/?:\@&=+\$,%#]+)$/;
	if(data.toString().match(pettern))
		return true;
	else
		return false;
}


/*-----------------------------------------------------------------------
- 郵便番号「XXX-XXXX, XXXXXXX（7桁）」 [data=str,int;]
-----------------------------------------------------------------------*/
UtilTools.prototype.isZip = function(data) {
	var pettern = /^\d{3}\-\d{4}$|^\d{7}$/;
	if(data.toString().match(pettern))
		return true;
	else
		return false;
}


/*-----------------------------------------------------------------------
- クレジットカード（VISA, MasterCard, American Express のフォーマットに対応） [data=str,int;]
-----------------------------------------------------------------------*/
UtilTools.prototype.isCreditcard = function(data) {
	var pettern = /^((4\d{3})|(5[1-5]\d{2})|(6011))([- ])?\d{4}([- ])?\d{4}([- ])?\d{4}|3[4,7]\d{13}$/;
	if(data.toString().match(pettern))
		return true;
	else
		return false;
}


/*-----------------------------------------------------------------------
- null判定 [data=*;]
-----------------------------------------------------------------------*/
UtilTools.prototype.isNull = function(data) {
	if(data == null)
		return true;
	else
		return false;
}


/*-----------------------------------------------------------------------
- undefined判定 [data=*;]
-----------------------------------------------------------------------*/
UtilTools.prototype.isUndefined = function(data) {
	if(data == undefined)
		return true;
	else
		return false;
}


/*-----------------------------------------------------------------------
- 空, null, undefined判定 [data=*]
-----------------------------------------------------------------------*/
UtilTools.prototype.isEmpty = function(data) {
	if(UtilTools.prototype.isNull(data) || UtilTools.prototype.isUndefined(data))
		return true;
	else if(data.toString().trim().length == 0)
		return true;
	else
		return false;
}


/*-----------------------------------------------------------------------
- isset [data=*]
-----------------------------------------------------------------------*/
UtilTools.prototype.isSet = function(data) {
	return !UtilTools.prototype.isUndefined(data);
}


/*-----------------------------------------------------------------------
- 文字数（上限以下か） [data=str,int; limit=int;]
-----------------------------------------------------------------------*/
UtilTools.prototype.isStringUpperLimit = function(data, limit) {
	if(data.toString().trim().length <= limit)
		return true;
	else
		return false;
}


/*-----------------------------------------------------------------------
- 文字数（下限以上か） [data=str,int; limit=int;]
-----------------------------------------------------------------------*/
UtilTools.prototype.isStringLowerLimit = function(data, limit) {
	if(data.toString().trim().length >= limit)
		return true;
	else
		return false;
}


/*-----------------------------------------------------------------------
- 機種依存文字 [data=-;]
-----------------------------------------------------------------------*/
UtilTools.prototype.isKishuizon = function(data) {
	var pettern = /^$/;
	if(data.toString().match(pettern))
		return true;
	else
		return false;
}


/*-----------------------------------------------------------------------
- 日付期間のチェック（開始～終了の間か） [data=str; start=str; end=str;]
-----------------------------------------------------------------------*/
UtilTools.prototype.isBetweenDatetime = function(data, start, end) {
	// data, start, endがすべて日付形式でなければfalseを返す
	if(!(UtilTools.prototype.isDatetime(data) && UtilTools.prototype.isDatetime(start) && UtilTools.prototype.isDatetime(end)))
		return false;
	
	var targetDate = new Date(data);
	var startDate = new Date(start);
	var endDate = new Date(end);
	
	if(startDate.getTime() <= targetDate.getTime() && targetDate.getTime() <= endDate.getTime())
		return true;
	else
		return false;
}


/*-----------------------------------------------------------------------
- 数値範囲（200～500の間か） [data=str,int,float; start=str,int,float; end=str,int,float;]
-----------------------------------------------------------------------*/
UtilTools.prototype.isBetweenNum = function(data, start, end) {
	// data, start, endがすべて数値でなければfalseを返す
	var isNumData = UtilTools.prototype.isNum(data) || UtilTools.prototype.isFew(data);
	var isNumStart = UtilTools.prototype.isNum(start) || UtilTools.prototype.isFew(start);
	var isNumEnd = UtilTools.prototype.isNum(end) || UtilTools.prototype.isFew(end);
	
	if(!(isNumData && isNumStart && isNumEnd))
			return false;
	
	if(parseFloat(start) <= parseFloat(data) && parseFloat(data) <= parseFloat(end))
		return true;
	else
		return false;
}


/*-----------------------------------------------------------------------
- ページ判定 [data=str;]
-----------------------------------------------------------------------*/
UtilTools.prototype.isPage = function(data) {
	if(~location.pathname.toString().indexOf(data))
		return true;
	else
		return false;
}


/*-----------------------------------------------------------------------
- ページ判定(正規表現) [data=str;]
-----------------------------------------------------------------------*/
UtilTools.prototype.isPageRegex = function(data) {
	var pattern = UtilTools.prototype.StrToRegexPattern(data);
	if(location.pathname.toString().match(pattern))
		return true;
	else
		return false;
}




/*-----------------------------------------------------------------------
- テンプレ [data=-;]
-----------------------------------------------------------------------*/
UtilTools.prototype.is = function(data) {
	var pettern = /^$/;
	if(data.toString().match(pettern))
		return true;
	else
		return false;
}


